import { render, staticRenderFns } from "./singleTable.vue?vue&type=template&id=f64c81e4"
import script from "./singleTable.vue?vue&type=script&lang=js"
export * from "./singleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports